import { ComponentClass, FunctionComponent, ReactNode } from 'react';
import { Store as notification } from 'react-notifications-component';

export interface iAlertMessage {
  title?: string;
  message: string;
  type: 'success' | 'info' | 'danger' | 'warning';
  position?:
    | 'top-right'
    | 'top-left'
    | 'top-center'
    | 'center'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center';
  content?: ComponentClass | FunctionComponent | ReactNode;
  durationInMinutes?: number;
}

export const AlertMessage = ({
  message,
  title,
  type,
  position = 'top-right',
  content = undefined,
  durationInMinutes = 0.08,
}: iAlertMessage): void => {
  notification.addNotification({
    title,
    message,
    content: content as any,
    type,
    id: `message-${type}`,
    insert: 'top',
    container: position,
    animationIn: ['animated', 'tada'],
    animationOut: ['animated', 'zoomOutRight'],
    dismiss: {
      duration: durationInMinutes * 60000,
      onScreen: true,
      pauseOnHover: true,
    },
  });
};
